import Allow from 'components/Allow';
import { useMainContext } from 'context/MainContext';
import { enumRules } from 'enum/enumRules';
import { ICurrency, INumberFormatCurrency } from 'interfaces/ICurrency';
import { IProductPriceHistory } from 'interfaces/IProductPriceHistory';
import React, { useCallback } from 'react';
import {
  Button,
  Col,
  FormControl,
  InputGroup,
  Row,
  Table
} from 'react-bootstrap';

import { Block, Check } from 'styled-icons/boxicons-regular';
import { masks } from 'utils/masks';
import TableTooltips from '../TableTooltips';

type Props = {
  list: IProductPriceHistory[] | null;
  setProductPriceHistoryList: React.Dispatch<
    React.SetStateAction<IProductPriceHistory[] | null>
  >;
  selectedCurrency: ICurrency;
};

const TablePriceHistoryListClient: React.FC<Props> = ({
  list,
  setProductPriceHistoryList,
  selectedCurrency
}) => {
  const { setDialog, profile } = useMainContext();
  const productPriceHistoryList = list as IProductPriceHistory[];

  const convertCurrency = (
    value: number,
    numberFormat: INumberFormatCurrency
  ): string => {
    const currencyFormatter = new Intl.NumberFormat(numberFormat.Locale, {
      style: 'currency',
      currency: numberFormat.Currency
    });
    return currencyFormatter.format(value);
  };

  return (
    <div>
      {productPriceHistoryList && productPriceHistoryList.length > 0 && (
        <Row>
          <Col>
            <h1>HISTÓRICO DE PREÇOS DE PRODUTOS POR CLIENTE</h1>
            <hr />
            <div className="table-thead-fixed">
              <Table className="table text-center" responsive>
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Nome</th>
                    <th>Nome Interno</th>
                    <th>Custo Base</th>
                    <th>Preço Base</th>
                    <th>Usuário</th>
                    <th>Data de criação</th>
                    <th>Data de cancelamento</th>
                  </tr>
                </thead>
                <tbody id="tbody-company">
                  {productPriceHistoryList.map(
                    (productPriceHistory: IProductPriceHistory) => (
                      <tr
                        key={`${productPriceHistory.ProductId}${
                          productPriceHistory.ClientId
                        }${productPriceHistory.CreatedDate ?? Math.random()}`}
                        style={{
                          color: ''
                        }}
                      >
                        <td>{productPriceHistory.ProductId}</td>
                        <td>{productPriceHistory.ProductName}</td>
                        <td>{productPriceHistory.ProductInternalName}</td>
                        <td>
                          {/* {convertCurrency(
                            productPriceHistory.CostCompany as number,
                            selectedCurrency?.NumberFormat as INumberFormatCurrency
                          )} */}
                          {productPriceHistory.CostCompany != null
                            ? convertCurrency(
                                productPriceHistory.CostCompany as number,
                                selectedCurrency?.NumberFormat as INumberFormatCurrency
                              )
                            : null}
                        </td>
                        <td>
                          {/* {convertCurrency(
                            productPriceHistory.PriceCompany as number,
                            selectedCurrency?.NumberFormat as INumberFormatCurrency
                          )} */}
                          {productPriceHistory.PriceCompany != null
                            ? convertCurrency(
                                productPriceHistory.PriceCompany as number,
                                selectedCurrency?.NumberFormat as INumberFormatCurrency
                              )
                            : null}
                        </td>
                        <td>{productPriceHistory.User}</td>
                        <td>{productPriceHistory.CreatedDate}</td>
                        <td>{productPriceHistory.DeletedDate}</td>
                      </tr>
                    )
                  )}
                </tbody>
              </Table>
            </div>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default TablePriceHistoryListClient;
